
const digest = 'd654fc05319febc13467b0953d0f1424d7fbf6b3ac09ade1414096450dfe3501';
const css = `._searchInput_sqdiw_1 {
    border: 1px solid #c1cbe4!important;
    min-height: 55px;
    font-size: 14px;
    font-weight: 400;
    border-radius: 15px;
    box-shadow: inset 0 3px 0 0 rgb(198 214 240 / 50%);
    padding: 18px 39px !important;
    color: #000;
    background-color: #dce7fa;
    position: relative;
    background-image: url(/dist/patientV3/icons/search.svg);
    background-repeat: no-repeat;
    background-position: left 15px center;
    display: block;
    width: 100%;
}
._wrapper_sqdiw_18 {
    margin-bottom: 0;
}`;

(function() {
  if (typeof document === 'undefined') {
    return;
  }
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"searchInput":"_searchInput_sqdiw_1","wrapper":"_wrapper_sqdiw_18"};
export { css, digest };
  